class RepertoireList extends Component {
    /**
     * @param el {HTMLElement}
     */
    constructor(el) {
        super(el);
        this.resultContainer = document.querySelector('[data-ajax-results]');
        this.ageFilterButtons = el.querySelectorAll('[data-age-filter-button]');
        this.addEventListeners();
    }

    /**
     * @param url {string}
     */
    loadRepertoire(url) {
        EventBus.getInstance().dispatchEvent("showGlobalSpinner");
        fetch(url + (url.includes('?') ? '&' : '?') + 'ajax=yes')
            .then(response => response.json())
            .then(data => {
                if (data.status === 'OK') this.onSuccess(data, url);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    /**
     * @param repertoire {string}
     */
    updateRepertoire(repertoire) {
        if (this.resultContainer) {
            this.resultContainer.outerHTML = repertoire;
            Component.initComponents();
        }
    }

    /**
     * @param data
     * @param url {string}
     */
    onSuccess(data, url) {
        history.pushState(null, null, url);
        this.$el.removeAttribute('data-initialized');
        this.updateRepertoire(data.repertoireHTML);
        EventBus.getInstance().dispatchEvent("hideGlobalSpinner");
    }

    /**
     * @param button {HTMLElement}
     * @param filterButtons {NodeListOf<HTMLElement>}
     */
    buttonSetActive(button, filterButtons) {
        filterButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
    }

    addEventListeners() {
        this.ageFilterButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.buttonSetActive(button, this.ageFilterButtons);
                this.loadRepertoire(button.dataset.filterUrl);
            });
        });
    }
}